import React from 'react';
import { FolderOpen } from 'lucide-react';
import EntityDocuments from '../../../documents/components/EntityDocuments';
import DocumentUploader from '../../../documents/components/DocumentUploader';
import { motion } from 'framer-motion';
import { deleteDocument } from '../../api/forumAPI';
import { useNotification } from '../../../../context/NotificationContext';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } }
};

export default function DossierDocuments({ dossierId, documents, onRefresh }) {
  const { showToast } = useNotification();

  const handleScanComplete = (extractedData) => {

    console.log("Scan IA terminé avec les données:", extractedData);
    if (onRefresh) onRefresh();
  };

  const handleUploadComplete = () => {
    if (onRefresh) onRefresh();
  };

  const handleDocumentDelete = async (documentId) => {
    try {
      await deleteDocument(dossierId, documentId);
      showToast("Document supprimé avec succès", "success");
      if (onRefresh) onRefresh();
    } catch (error) {
      console.error(error);
      showToast("Erreur lors de la suppression du document", "error");
    }
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="space-y-6"
    >
      <motion.div variants={itemVariants} className="workspace-card p-6 mb-6">
        <h3 className="text-lg font-bold text-primary flex items-center mb-1">
          <FolderOpen className="w-5 h-5 mr-2 text-tertiary" />
          Pièces & Documents
        </h3>
        <p className="text-sm text-tertiary">Déposez et retrouvez l'ensemble des fichiers relatifs à ce dossier (Contrats, Analyses, Justificatifs...).</p>
      </motion.div>

      <motion.div variants={itemVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="workspace-card p-6 flex flex-col h-full">
          <EntityDocuments documents={documents} onDelete={handleDocumentDelete} />
        </div>

        <div className="flex flex-col h-full">
          <DocumentUploader
            dossierId={dossierId}
            onUploadComplete={handleUploadComplete}
            onScanComplete={handleScanComplete}
          />
        </div>
      </motion.div>
    </motion.div>
  );
}
